import { VerifyAccountUrl } from '../../constants/urls';
import { CalloutContent, CalloutVariant } from '../../entities/callout-content.entity';
import { ProgramList } from '../../constants/program-list';
import { AlbertaSupportsContactCentreTollFree } from '../common/contact-info';
import { DialogContent } from '../../entities/dialog-content.entity';

const diaName = ProgramList.dia;
const aishName = ProgramList.aish;
const adapName = ProgramList.adap;

const calloutTollFreePhone = '1-877-969-3006';
const calloutLocalPhone = '587-469-3006';
const calloutEmail = 'AISHApply@gov.ab.ca';

const trusteeUrl = 'https://www.alberta.ca/trusteeship';

export const AishCallout_Dependents_AgeIneligible = {
  calloutVariant: CalloutVariant.Emergency,
  headerText: 'You cannot claim this person as a dependent',
  bodyText: `A Dependent is a child who is dependent on you for support and lives with you and:
  <ul>
    <li>does not have a spouse or partner</li>
    <li>is under 18, or is 18 or 19 and going to High School</li>
  </ul>`,
} as CalloutContent;

export const AishCallout_Income_EligibleCdb_Default = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Apply for DTC and/or CDB`,
  bodyText: `Please note you must be eligible for the DTC to be eligible for CDB. ${diaName.abbreviation} requires applicants to access 
  all sources of income for which they are eligible, and CDB is a benefit you may be entitled to.`,
} as CalloutContent;

export const AishCallout_Income_EligibleCdb_OboDefault = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Apply for DTC and/or CDB`,
  bodyText: `Please note <<oboName>> must be eligible for the DTC to be eligible for CDB. 
  ${diaName.abbreviation} requires applicants to access all sources of income for which they are eligible, and CDB is a benefit they may be entitled to.`,
} as CalloutContent;

export const AishCallout_Income_EligibleCdb_OboSpousePartner = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Apply for DTC and/or CDB`,
  bodyText: `Please note <<oboName>> must be eligible for the DTC to be eligible for CDB. 
  ${diaName.abbreviation} requires applicants to access all sources of income for which they are eligible, and CDB is a benefit they may be entitled to.`,
} as CalloutContent;

export const AishCallout_Assets_InformationRequired_Default = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Assets information required`,
  bodyText: `You can come back to finish this section later. You may need some time to gather your documents. Before you can submit your application, you will need to tell us about your assets.`,
} as CalloutContent;

export const AishCallout_Assets_InformationRequired_OboDefault = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Assets information required`,
  bodyText: `You can come back to finish this section later. You may need some time to gather the documents. Before you can submit this application, you will need to tell us about <<oboName>>'s assets.`,
} as CalloutContent;

export const AishCallout_SubmissionBox_Submitted_Default = {
  calloutVariant: CalloutVariant.Success,
  headerText: `Application submitted`,
  bodyText: `Your application has been successfully sent to ${diaName.abbreviation} Support. We will contact you if further information is needed.<br/><br/>If your situation has changed or you have additional information, please provide it when ${diaName.aOrAn} ${diaName.abbreviation} Support worker contacts you.<br/><br/><b>Note:</b> In order to safeguard your privacy and the security of your information, your submitted application will be deleted 12 months after the submitted date.`,
} as CalloutContent;

export const AishCallout_SubmissionBox_Submitted_OboDefault = {
  calloutVariant: CalloutVariant.Success,
  headerText: `Application submitted`,
  bodyText: `Application for <<oboFullName>> has been successfully sent to ${diaName.abbreviation} Support. We will contact you if further information is needed.<br/><br/>If <<oboFullName>>'s situation has changed or you have additional information, please provide it when ${diaName.aOrAn} ${diaName.abbreviation} Support worker contacts you. If you have additional documents to submit, you can add them to <<oboFullName>>'s application from the dashboard.<br/><br/><b>Note:</b> In order to safeguard <<oboFullName>>'s privacy and the security of their information, submitted application will be deleted 12 months after the submitted date.`,
} as CalloutContent;

export const AishCallout_Skip_Printing = {
  calloutVariant: CalloutVariant.Information,
  headerText: 'Want to skip printing and signing?',
  bodyText: `If you would like to sign this form digitally, verify your <a href="${VerifyAccountUrl}" target="_blank">Alberta.ca Account</a> . You will not need
  to print, sign, or upload the Consent and Declaration form. After verifying your account, sign out and sign back into your application - this page will change 
  and you will be able to provide your Consent and Declaration digitally by clicking the checkboxes.`,
} as CalloutContent;

export const AishCallout_Get_Verified = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Verify your account`,
  bodyText: `<a href="${VerifyAccountUrl}" target="_blank">Verify your Alberta.ca account</a> for a better experience:<br/>
  <ul>
  <li><b>Apply faster </b>– Depending on your situation, you won’t need to download, print, sign, and upload some or all forms.</li>
  <li><b>Protect your identity </b>– Helps make sure no one else can use your account.</li>
  </ul>`,
} as CalloutContent;

export const AishCallout_AccessCodePage_BasicUser = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Verify your account`,
  bodyText: `You are currently logged in with a Basic Alberta.ca Account. To provide your consent digitally (online), verify your <a href="${VerifyAccountUrl}" target="_blank">Alberta.ca</a> Account. 
  <p>If you choose to continue with your Basic account, you will still be able to review the information and provide your CRA Consent form but you will need to download it, print, sign, scan or take picture of the CRA Consent and upload the file.</p>`,
} as CalloutContent;

export const AishCallout_SignerPage_Verified = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Your ${diaName.abbreviation} CRA Consent is complete`,
  bodyText: `You have successfully provided CRA Consent for your spouse/partner's ${diaName.abbreviation} application. 
  We've sent your spouse/partner an email to let them know that they can now submit the application.`,
} as CalloutContent;

export const AishCallout_SignerPage_Inactive = {
  calloutVariant: CalloutVariant.Information,
  headerText: 'Application not available',
  bodyText: `This application is no longer available for you to sign. Please speak to the person who shared it with you.`,
} as CalloutContent;

export const AishCallout_SignerPage_Rejected = {
  calloutVariant: CalloutVariant.Important,
  headerText: 'CRA Consent not provided',
  bodyText: `<p>You have chosen not to provide your CRA Consent at this time. Your spouse/partner can not submit their ${diaName.abbreviation} application without your CRA Consent.</p><p>Please speak with your spouse/partner about your concerns. They can send you a new invitation or they can print the CRA Consent for you to sign.</p>`,
} as CalloutContent;

export const AishCallout_SignerPage_TopDescription = {
  calloutVariant: CalloutVariant.Information,
  headerText: 'Review your information',
  bodyText: `<p>Your spouse/partner has completed ${diaName.aOrAn} ${diaName.abbreviation} application, and your CRA Consent is required before they can submit the application.</p>
  <p>This application requires your spouse/partner to provide a full picture of the household financial situation, including details of your income and assets, as well as personal information such as your name, date of birth and Social Insurance Number.</p>
  <p>Please:</p>
  <ul>
    <li>Review the information your spouse/partner has shared about you</li>
    <li>Provide your CRA Consent</li>
  </ul>  
  <h3>See a mistake?</h3>
  <p>If you see something that needs to be changed, let your spouse/partner know and they can update the application. This page will automatically refresh and you will be able to see the change.</p>
  <p>If you have any questions or require assistance, you can call the Alberta Supports Contact Centre at <a href="tel:${AlbertaSupportsContactCentreTollFree}">${AlbertaSupportsContactCentreTollFree}</a> or fill out the <a href="https://www.alberta.ca/contact-alberta-supports" target="_blank">contact form</a></p>`,
} as CalloutContent;

export const AishCallout_SignerPage_BasicUserCraDescription = {
  calloutVariant: CalloutVariant.Important,
  headerText: 'CRA Consent',
  bodyText: `You are signed in with your <strong>Alberta.ca Basic Account</strong>. To provide your consent digitally (online), verify your <a href="${VerifyAccountUrl}" target="_blank">Alberta.ca Account</a>.
  <p>Once you're verified, go back to the Consent request email, click the link, and sign in with your verified account.</p>
  <p>If you choose to continue with your Basic account, you will need to download, print, sign, scan or take picture of the CRA Consent and upload the file.</p>`,
} as CalloutContent;

export const AishCallout_DashBoardPage_MaxApplicationSubmitted = {
  calloutVariant: CalloutVariant.Important,
  headerText: `You already have two ${diaName.fullName} applications submitted.`,
  bodyText: `You cannot start a new application at this time.`,
} as CalloutContent;

export const AishCallout_PrescreenPage_ReceivedBenefitAndStopped = {
  calloutVariant: CalloutVariant.Emergency,
  emphasis: 'medium',
  headerText: 'Call Alberta Supports to reapply',
  bodyText: `If you stopped receiving benefits from ${aishName.abbreviation} or ${adapName.abbreviation} within the past two years, contact an <a href="https://www.alberta.ca/contact-aish" target="_blank"> Alberta Supports office </a> to find out how to apply.`,
} as CalloutContent;

export const AishCallout_PrescreenPage_ReapplyBenefit = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Continue with this application`,
  bodyText: `<p>If you received a letter telling you that on <<adapDate>>, your file was transitioned to ${adapName.abbreviation}, you have the option to apply for ${aishName.abbreviation} using the new ${diaName.fullName} (${diaName.abbreviation}) application.</p> 
  <p>Alberta’s government will cover the cost of one medical assessment for current ${aishName.abbreviation} clients who transition to ${adapName.abbreviation} in July 2026 and later choose to be assessed for ${aishName.abbreviation}.</p>`,
} as CalloutContent;

export const AishCallout_PrescreenPage_ReceivedBenefitAndStopped_OnBehalf = {
  calloutVariant: CalloutVariant.Emergency,
  headerText: `Contact Alberta Supports office`,
  bodyText: `If the person you are applying for stopped receiving benefits from ${aishName.abbreviation} or ${adapName.abbreviation} within the past two years, contact an <a href="https://www.alberta.ca/contact-aish" target="_blank"> Alberta Supports office </a> to find out how to apply.`,
} as CalloutContent;

export const AishCallout_PrescreenPage_ReapplyBenefit_OnBehalf = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Option to apply for ${aishName.abbreviation}`,
  bodyText: `<p>If the person you are applying for received a letter telling them that on <<adapDate>>, their file was transitioned to ${adapName.abbreviation}, they have the option to apply for ${aishName.abbreviation} using the new ${diaName.fullName} (${diaName.abbreviation}) application.</p> 
  <p>Alberta’s government will cover the cost of one medical assessment for current ${aishName.abbreviation} clients who transition to ${adapName.abbreviation} in July 2026 and later choose to be assessed for ${aishName.abbreviation}.</p>`,
} as CalloutContent;

export const AishCallout_ProceedPage_RightPlace = {
  calloutVariant: CalloutVariant.Success,
  headerText: 'You’re in the right place',
  bodyText: 'You may be eligible for Disability Income Assistance. You need an Alberta.ca Account to apply.',
} as CalloutContent;

export const AishCallout_ProceedPage_RightPlace_OnBehalf = {
  calloutVariant: CalloutVariant.Success,
  headerText: 'You’re in the right place',
  bodyText:
    'The person you are applying for may be eligible for Disability Income Assistance. You need an Alberta.ca Account to apply.',
} as CalloutContent;

export const AishCallout_ProceedPage_OnBehalf_WorkRelatedSigner = {
  calloutVariant: CalloutVariant.Success,
  headerText: 'You are the legal signer of this application, and there are two ways to apply:',
  bodyText: `<ul>
  <li>Best option - do not sign in with your personal Alberta.ca Account. Instead, use or create a Basic Alberta.ca Account associated 
  with your work email. You will be able to submit ${diaName.abbreviation} applications for multiple applicants this way.</li>
  <li>Or help the applicant apply using their own Alberta.ca Account.</li>
  </ul>
  <p>Either way, you will have to print the forms and sign them by hand. You can then upload the signed forms to submit with the application.</p>`,
} as CalloutContent;

export const AishCallout_ProceedPage_OnBehalf_PersonalSigner = {
  calloutVariant: CalloutVariant.Success,
  headerText: 'You are the legal signer of this application.',
  bodyText: 'Use your personal Alberta.ca Account to apply on their behalf.',
} as CalloutContent;

export const AishCallout_ProceedPage_OnBehalf_ParentGuardian = {
  calloutVariant: CalloutVariant.Success,
  headerText:
    'You are the legal signer of this application. Use your personal Alberta.ca Account to apply on their behalf.',
  bodyText: `Note: you cannot start or submit an application until 6 months prior to your child’s 18th birthday.`,
} as CalloutContent;

export const AishCallout_ProceedPage_OnBehalf_ApplicantCanSign = {
  calloutVariant: CalloutVariant.Success,
  headerText: 'The applicant has to sign this application, and there are two ways to apply:',
  bodyText: `<ul>
  <li>Best option - help them apply using their own Alberta.ca Account. If their account is verified, they can sign digitally instead of 
  printing the forms to sign.</li>
  <li>Or use your own Alberta.ca Account to help them apply. You will have to print the forms so they can sign them by hand. You can then 
  upload the signed forms to submit with the application.</li>
  </ul>`,
} as CalloutContent;

export const AishCallout_ProceedPage_OnBehalf_ApplicantCannotSign = {
  calloutVariant: CalloutVariant.Emergency,
  headerText: 'You will need to arrange legal authority before applying',
  bodyText:
    'Someone must become their Power of Attorney or Trustee, and then sign in with their own Alberta.ca Account.',
} as CalloutContent;

export const AishCallout_DashboardPage_ApplicationChange = {
  calloutVariant: CalloutVariant.Important,
  headerText: 'Your application has changed',
  confirmButtonText: 'Continue application',
  cancelButtonText: 'Back',
  bodyText: `As of <<adapDate>>, the ${aishName.abbreviation} application is now part of the combined ${diaName.fullName} application, which covers both ${aishName.abbreviation} and ${adapName.abbreviation}.
  <p>The information you provide will help determine which program you may be eligible for.</p>
  <p>Some questions and sections have changed, so you may need to answer new questions or complete some sections again before you submit your application.</p>`,
} as CalloutContent;

export const AishCallout_DashboardPage_OboApplicantTurned18 = {
  calloutVariant: CalloutVariant.Important,
  headerText: 'Your application has changed',
  confirmButtonText: 'Continue',
  cancelButtonText: 'Back',
  bodyText: `<p>The signing authority on this application may have changed because the person you are applying for is now 18 years old.</p>
  <p>Answer the new questions appearing on the “Your Relationship” page to understand who needs to sign this application.</p>`,
} as CalloutContent;

export const AishCallout_DashboardPage_AddDocuments = {
  calloutVariant: CalloutVariant.Information,
  confirmButtonText: 'Add documents',
  cancelButtonText: 'Back',
  headerText: 'Add documents',
  bodyText: `If you need to provide additional documents related to your submitted ${diaName.abbreviation} application, you can select "Add documents" and complete the form.`,
} as DialogContent;

export const AishCallout_Medical_DoctorSubmitting = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Submitting the ${diaName.abbreviation} Medical Report`,
  bodyText: `You have indicated that your health professional will be sending the report.
  <p>They can:</p>
  <ul>
    <li>submit it by email to: <a href="mailto:${calloutEmail}">${calloutEmail}</a></li>
    <li>fax it to <a href="tel:${calloutLocalPhone}">${calloutLocalPhone}</a> (Edmonton Area) or 
      <a href="tel:${calloutTollFreePhone}">${calloutTollFreePhone}</a> (rest of Alberta), or</li>
    <li>mail it to PO Box 17000 Station Main, Edmonton, AB, T5J 4B3</li>
  </ul>`,
} as CalloutContent;

export const AishCallout_Medical_DoctorSubmitting_OnBehalf = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Submitting the ${diaName.abbreviation} Medical Report`,
  bodyText: `You have indicated that <<oboName>>'s health professional will be sending the report.
  <p>They can:</p>
  <ul>
    <li>submit it by email to: <a href="mailto:${calloutEmail}">${calloutEmail}</a></li>
    <li>fax it to <a href="tel:${calloutLocalPhone}">${calloutLocalPhone}</a> (Edmonton Area) or 
      <a href="tel:${calloutTollFreePhone}">${calloutTollFreePhone}</a> (rest of Alberta), or</li>
    <li>mail it to PO Box 17000 Station Main, Edmonton, AB, T5J 4B3</li>
  </ul>`,
} as CalloutContent;

export const AishCallout_Medical_UploadReport = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Upload ${diaName.abbreviation} Medical Report`,
  bodyText: `Upload the completed ${diaName.abbreviation} Medical Report provided by your health professional below.`,
} as CalloutContent;

export const AishCallout_Medical_UploadReport_OnBehalf = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Upload ${diaName.abbreviation} Medical Report`,
  bodyText: `Upload the completed ${diaName.abbreviation} Medical Report provided by <<oboName>>'s health professional below.`,
} as CalloutContent;

export const AishCallout_Consent_Intro = {
  headerText: `Review and provide consents`,
  calloutVariant: CalloutVariant.Information,
  bodyText: `<p>
  Your legal permission is required to share information with others to help determine if you qualify for ${diaName.abbreviation} benefits. If you agree with the statements, please check the box in each section.</p>`,
};
export const AishCallout_Mainpage_Intro = {
  calloutVariant: CalloutVariant.Information,
  headerText: `${diaName.abbreviation} covers ${aishName.abbreviation} and ${adapName.abbreviation}`,
  bodyText: `<p>
  The ${diaName.combinedName} application covers two programs: 
  ${aishName.combinedName} and the ${adapName.combinedName}. 
  Both programs provide supports to Albertans with disabilities.
  </p>`,
};

export const AishCallout_SpousePartner_Intro = {
  headerText: `Your spouse/partner will need to sign`,
  calloutVariant: CalloutVariant.Information,
  bodyText: `<p>Please note that the signature of your spouse/partner will be required on the consent and declaration form.</p>`,
};

export const AishCallout_ReviewPage_Locked = {
  headerText: `You can now submit your application`,
  calloutVariant: CalloutVariant.Success,
  bodyText: `<p>Your spouse/partner has successfully signed the CRA Consent. You can now submit your application.</p>
    <p>
      You can no longer make changes to this application. If you need to change any information provided, you can do so
      when a worker calls you to review your application.
    </p>`,
};

export const AishCallout_MySituation_CurrentClientReapplying = {
  calloutVariant: CalloutVariant.Information,
  headerText: `We already have some of your information`,
  bodyText: `<p>Because you're a current ${adapName.abbreviation} client who received ${aishName.abbreviation} before, you have fewer questions to answer. You will still need to include a medical report.</p>`,
} as CalloutContent;

export const AishCallout_MySituation_ReapplyBenefit_OnBehalf = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Continue with this application`,
  bodyText: `<p>If <<oboName>> received a letter telling them that on <<adapDate>> their file was transitioned to ${adapName.abbreviation}, they have the option to apply for ${aishName.abbreviation} using the new ${diaName.fullName} (${diaName.abbreviation}) application.</p> 
  <p>Alberta’s government will cover the cost of one medical assessment for current ${aishName.abbreviation} clients who transition to ${adapName.abbreviation} in July 2026 and later choose to be assessed for ${aishName.abbreviation}.</p>`,
} as CalloutContent;

export const AishCallout_MySituation_ReceivedBenefitAndStopped_OnBehalf = {
  calloutVariant: CalloutVariant.Emergency,
  emphasis: 'medium',
  headerText: 'Call Alberta Supports to reapply',
  bodyText: `If <<oboName>> stopped receiving benefits from ${aishName.abbreviation} or ${adapName.abbreviation} within the past two years, contact an <a href="https://www.alberta.ca/contact-aish" target="_blank"> Alberta Supports office </a> to find out how to apply.`,
} as CalloutContent;

export const AishCallout_YourRelationship_SigningAuthorityChange = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Signing authority may change`,
  bodyText: `<p>If your child turns 18 before you submit this application, you may no longer have the legal authority to sign for them.</p>
  <p>If your child is 18 and cannot understand or sign the application themselves, you'll need Power of Attorney or a Trusteeship order to be able to sign on their behalf.</p>`,
} as CalloutContent;

export const AishCallout_YourRelationship_TrusteeLegalGuardian_Required = {
  calloutVariant: CalloutVariant.Important,
  headerText: `You need to be appointed as Trustee or Legal Guardian before you can apply`,
  bodyText: `<p>You've told us you don't have legal authority to act for <<oboName>>. Because <<oboName>> is under 18 years old, you'll need to be formally appointed as their Trustee or Guardian first.</p>
  <p>Being appointed is a separate legal process, so it's worth starting as soon as you can. Once you're appointed, come back and sign in with your own <a href="<<albertaCaAccountUrl>>" target="_blank">Alberta.ca</a> Account to continue.</p>
  <p><a href="${trusteeUrl}" target="_blank">How to apply to become a Trustee</a><br />
  <a href="https://www.alberta.ca/apply-child-guardianship" target="_blank">How to apply to become a Guardian</a></p>`,
} as CalloutContent;

export const AishCallout_YourRelationship_Trustee_Required = {
  calloutVariant: CalloutVariant.Important,
  headerText: `You need to be appointed as Trustee before you can apply`,
  bodyText: `<p>You've told us you don't have legal authority to act for <<oboName>>, and that they can't understand or sign this application themselves. To apply on their behalf, you'll need to be formally appointed as their <a href="${trusteeUrl}" target="_blank">Trustee</a> first.</p>
  <p>A Trustee is legally authorized to manage another person's financial and legal matters, including applying for ${diaName.fullName} on their behalf. Being appointed is a separate legal process, so it's worth starting as soon as you can.
  Once you're appointed, come back and sign in with your own <a href="<<albertaCaAccountUrl>>" target="_blank">Alberta.ca</a> Account to continue.</p> 
  <p><strong>Why can't I get Power of Attorney instead?</strong><br />
  A Power of Attorney can only be set up while a person can still understand and agree to it. Once they can't, being appointed as a Trustee through the court is the way to get legal authority.</p>`,
} as CalloutContent;

export const AishCallout_YourRelationship_TrusteeLegalGuardian_Appointed = {
  calloutVariant: CalloutVariant.Important,
  headerText: `You need to be appointed as Trustee or Legal Guardian before you can apply`,
  bodyText: `<p>You've told us you don't have legal authority to act for <<oboName>>. Because <<oboName>> is under 18 years old, you'll need to be formally appointed as their Trustee or Guardian first.</p>
  <p>Being appointed is a separate legal process, so it's worth starting as soon as you can. Once you're appointed, come back and sign in with your own <a href="<<albertaCaAccountUrl>>" target="_blank">Alberta.ca</a> Account to continue.</p>
  <p><a href="${trusteeUrl}" target="_blank">How to apply to become a Trustee</a><br />
  <a href="https://www.alberta.ca/apply-child-guardianship" target="_blank">How to apply to become a Guardian</a></p>`,
} as CalloutContent;
